// src/components/sections/donation/DonationSection.jsx
import React, { useState } from 'react';
import { Heart, Coffee, Gift, Sparkles } from 'lucide-react';

const DonationSection = () => {
  const [selectedAmount, setSelectedAmount] = useState(null);

  const donationAmounts = [
    { 
      amount: 5, 
      icon: <Coffee className="w-6 h-6" />, 
      label: "Buy us a coffee",
      stripeLink: "https://donate.stripe.com/4gM4gz6iu2liedndbU28806",
      imagePlaceholder: "coffee-donation.JPG" // Coffee cup image
    },
    { 
      amount: 18, 
      icon: <Heart className="w-6 h-6" />, 
      label: "Show some love",
      stripeLink: "https://donate.stripe.com/14A6oHdKW4tq3yJb3M28807",
      imagePlaceholder: "heart-donation.JPEG" // Hiker/mountain image
    },
    { 
      amount: 36, 
      icon: <Gift className="w-6 h-6" />, 
      label: "Double the LOVE",
      stripeLink: "https://donate.stripe.com/5kQcN55eq2lic5f5Js28808",
      imagePlaceholder: "gift-donation.JPG" // Packed suitcase image
    },
    { 
      amount: 98, 
      icon: <Sparkles className="w-6 h-6" />, 
      label: "Be the change you want to see in the world :)",
      stripeLink: "https://donate.stripe.com/bJe4gzayK3pm6KVfk228809",
      imagePlaceholder: "sparkles-donation.JPG" // Drone over canyon image
    }
  ];

  const handleDonation = (stripeLink) => {
    window.open(stripeLink, '_blank');
  };

  return (
    <section id="support" className="py-20 bg-gradient-to-b from-[#F7F7F7] to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-[#FF6B35] to-[#FF8C35]">
              If you've already supported a startup this month, please think of us next time :)
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Our itineraries are now free, but hosting the website, renting the domain, and creating quality travel content isn't. 
              Your support helps us to help you travel safely.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {donationAmounts.map((donation, index) => (
              <div
                key={index}
                onClick={() => handleDonation(donation.stripeLink)}
                className="cursor-pointer transform transition-all duration-300 hover:scale-105 group"
              >
                {/* Image Card with Amount Overlay */}
                <div className="relative bg-white rounded-xl shadow-lg overflow-hidden border-2 border-transparent hover:border-[#FF6B35] hover:shadow-xl transition-all duration-300">
                  {/* Background Image */}
                  <div 
                    className="h-48 bg-cover bg-center bg-no-repeat"
                    style={{ 
                      backgroundImage: `url('/images/${donation.imagePlaceholder}')` 
                    }}
                  >
                    {/* Dark overlay for better contrast */}
                    <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
                    
                    {/* Amount in Center */}
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="bg-white bg-opacity-40 backdrop-blur-sm rounded-lg px-6 py-3 shadow-lg">
                        <h3 className="text-3xl font-bold text-gray-800">
                          ${donation.amount}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Description Text Below Image */}
                <div className="mt-4 text-center">
                  <p className="text-gray-700 text-sm font-medium">
                    {donation.label}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
            <div className="flex items-center justify-center mb-4">
              <Heart className="w-8 h-8 text-red-500 mr-2" />
              <span className="text-lg font-medium text-gray-700">
                Custom Amount
              </span>
            </div>
            <p className="text-gray-600 mb-6">
              Want to contribute a different amount? No problem... We made a special link for you ;)
            </p>
            <button
              onClick={() => {
                window.open('https://donate.stripe.com/28E6oHcGS6By0mxc7Q2880a', '_blank');
              }}
              className="inline-flex items-center bg-gradient-to-r from-[#FF6B35] to-[#FF8C35] hover:from-[#E55A2B] hover:to-[#E5712B] text-white px-8 py-3 rounded-full transition-all transform hover:scale-105 shadow-lg hover:shadow-xl font-medium"
            >
              <Gift className="w-5 h-5 mr-2" />
              Choose Custom Amount
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonationSection;